import { module } from 'modujs';
import { html } from '../utils/environment';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                prev: 'prev',
                next: 'next'
            }
        }
    }

    init() {

        let slidesPerView = 1;

        if(html.getAttribute('data-container-size') === 'small' && this.el.getAttribute('data-module-carousel') ==='sos-info') {
            slidesPerView = 1.5;
        } else if (html.getAttribute('data-container-size') === 'small' && this.el.getAttribute('data-module-carousel') ==='news') {
            slidesPerView = 2.5;
        } else {
            slidesPerView = this.getData('slides');
        }

        this.swiper = new Swiper(this.$('slideshow')[0], {
            slidesPerView: 1.1,
            speed: 600,
            scrollbar: {
                el: this.$('scrollbar')[0],
                draggable: true
            },
            breakpoints: {
                1000: {
                    slidesPerView: ((this.getData('slides') === 3) ? 2 : this.getData('slides')),
                },
                1200: {
                    slidesPerView: slidesPerView
                }
            }
        });

        this.swiper.on('slideChange',() => {
            this.check();
        });

        this.check();

    }

    check() {
        if(this.swiper.isBeginning) {
            this.el.classList.add('is-beginning');
        } else {
            this.el.classList.remove('is-beginning');
        }

        if(this.swiper.isEnd) {
            this.el.classList.add('is-end');
        } else {
            this.el.classList.remove('is-end');
        }
    }

    prev() {
        this.swiper.slidePrev();
    }

    next() {
        this.swiper.slideNext();
    }
}
